import { initBrowserAxios } from '../axios';

import { commerceConnectorApiFetchers } from './commerce-connector-api';
import { myProductsApiFetchers } from './my-products-api';
import { productsApiFetchers } from './products-api';
import { productsParametersApiFetchers } from './products-parameters-api';
import { productsInfoApiFetchers } from './products-info-api';
import { translationsApiFetchers } from './translations-api';
import { channelSightApiFetchers } from './channel-sight-api';
import { bazaarVoiceApiFetchers } from './bazaar-voice-api';
import { productAvailabilityApiFetchers } from './product-availability-api';
import { apcCtaApiFetchers } from './apc-cta-api';
import { analyticsApiFetchers } from './analytic-lookups';
import { comparisonBundleProductsApiFetchers } from './comparison-bundle-products-api';
import { ctaShoppableApiFetchers } from './pes-cta-shoppable-api';
import { substitutionProductsApiFetchers } from './susbstitution-products-api';
import { relatedProductsApiFetchers } from './related-products-api';

initBrowserAxios();

export const fetchers = {
  ...productsApiFetchers,
  ...productsParametersApiFetchers,
  ...productsInfoApiFetchers,
  ...translationsApiFetchers,
  ...myProductsApiFetchers,
  ...commerceConnectorApiFetchers,
  ...channelSightApiFetchers,
  ...bazaarVoiceApiFetchers,
  ...productAvailabilityApiFetchers,
  ...apcCtaApiFetchers,
  ...analyticsApiFetchers,
  ...comparisonBundleProductsApiFetchers,
  ...ctaShoppableApiFetchers,
  ...substitutionProductsApiFetchers,
  ...relatedProductsApiFetchers,
};
